'use client';
import dynamic from 'next/dynamic';
import { memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Modal } from '~components/Modals/Base';
import { useEmailConfirm } from '~features/emailConfirm/hooks/useEmailConfirm';
import { emailConfirmActions } from '~store/email-confirm';

import { useEmailConfirmModal } from '../../hooks/useEmailConfirmModal';
import type { ActiveModal } from '../../model/types';
import { modalStyle } from './styles';

const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const EmailConfirmModal = memo(() => {
	const dispatch = useDispatch();
	const { isOpened, open, close } = useEmailConfirmModal();
	const { required: isRequired } = useEmailConfirm();

	const [activeModal, setActiveModal] = useState<ActiveModal>('change');

	useEffect(() => {
		if (isRequired) {
			// sent during sign up
			dispatch(emailConfirmActions.setLastSent());
			setActiveModal('sent');
			open();
		}
	}, [isRequired, dispatch, open]);

	return (
		<Modal
			open={isOpened}
			locked={isRequired}
			className={modalStyle}
			onClose={close}
		>
			<Content
				activeModal={activeModal}
				setActiveModal={setActiveModal}
				isRequired={isRequired}
			/>
		</Modal>
	);
});

EmailConfirmModal.displayName = 'EmailConfirmModal';
